
import { Component, Input, AfterContentInit, AfterViewInit, ElementRef, OnInit } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { HelpElementDTO } from './help.dtos';
import { UserService } from '../../../user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HelpService } from './help.service';
import { BaseComponent } from '../baseComponent/base.component';
import { Store } from '@ngrx/store';
import { UserPrefs, MainViewPrefs } from '../../../api/UserPrefs-dto';
import { AppState } from '../../../store/AppState';


@Component({
  selector: 'plyca-helpElement',
  templateUrl: 'helpElement.template.html'
})
export class HelpElementComponent extends BaseComponent implements AfterContentInit, AfterViewInit, OnDestroy, OnInit {
  @Input()
  showTitle: boolean;
  @Input()
  helpElement: HelpElementDTO;
  @Input()
  indexStr: string;
  @Input()
  indexLevel: number;
  private loaded = false;
  public displayVideo: boolean;
  public displayRef: boolean;

  sanitizedExternalLink: any;
  sanitizedContent: any;
  sanitizedMultimediaContentLink: any;
  userPrefs: UserPrefs;


  constructor(public userService: UserService,
    protected sanitizer: DomSanitizer,
    protected helpService: HelpService,
    private store: Store<AppState>,
    private elem: ElementRef) {
    super();

    this.subscribe(this.store
      .select('userPrefs'),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;

        if (!this.userPrefs.mainViewPrefs) {
          this.userPrefs.mainViewPrefs = new MainViewPrefs();
        }
      });

  }

  ngOnInit(): void {


  }

  ngAfterContentInit() {

    if (this.isExternalLink(this.helpElement)) {
      this.sanitizedExternalLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.helpElement.externalLink);
    }
    this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(this.helpElement.content);
    if (this.isMultimediaContentLink(this.helpElement)) {
      this.sanitizedMultimediaContentLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.helpElement.multimediaLink);
    }

  }

  ngAfterViewInit(): void {

    this.subscribe(this.helpService.generateInternalLinks(this.elem));

  }
  ngOnDestroy() {

    super.ngOnDestroy();
  }


  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById(this.helpElement.identifier).innerHTML;
    const stylesHtml = this.getTagsHtml('style');
    const linksHtml = this.getTagsHtml('link');
    popupWin = window.open('', '_print-window', 'top=0,left=0,height=80%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
        <head>
          <title>${this.helpElement.name}</title>
          ${linksHtml}
          ${stylesHtml}
        </head>
    <body onload="window.print();window.close()">
      <div class="container-fluid  display-print">
      <div class="row">
      <div class="col-12">
      <div class="ui-editor-content ql-container ql-snow ql-disabled">${printContents}</div>
      </div>
      </div>
      </div>
    </body>
    </html>`);
    popupWin.document.close();
  }

  private getTagsHtml(tagName: keyof HTMLElementTagNameMap): string {
    const htmlStr: string[] = [];
    const elements = document.getElementsByTagName(tagName);
    for (let idx = 0; idx < elements.length; idx++) {
      htmlStr.push(elements[idx].outerHTML);
    }

    return htmlStr.join('\r\n');
  }

  isExternalLink(helpElement: HelpElementDTO) {
    return helpElement.externalLink != undefined && helpElement.externalLink != '';
  }
  isMultimediaContentLink(helpElement: HelpElementDTO) {
    return helpElement.multimediaLink != undefined && helpElement.multimediaLink != '';
  }

  isFormFieldHelp() {
    return this.helpElement.type && this.helpElement.type === 'AYUDA' && this.helpElement.tags
      && this.helpElement.tags.find(entry => entry.startsWith('FLD_'));
  }

  getContainerEditorClass() {
    if (this.helpElement.editor && this.helpElement.editor === 'html')
      return '';
    else
      return ' ui-editor-content ql-container ql-snow ql-disabled ';
  }
  getEditorClass() {
    if (this.helpElement.editor && this.helpElement.editor === 'html')
      return '';
    else
      return ' ql-editor ';
  }

}
